$('.rhino-video-image-caption').one('click', function() {
  $(this).find('.mejs-controls').css('display', 'none')
    .delay(1000)
    .queue(function(visible) {
      $(this).css('display', 'flex');
    })
})

$('.rhino-video-cta__video').one('click', function() {
  $(this).find('.overlay-wrap').fadeOut();
  $(this).siblings('.rhino-video-cta__text').fadeOut();
  $(this).find('iframe')[0].src += "&autoplay=1";
})